import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { MaterialApi } from './apis/material-api';
import { MaterialApiImpl } from './apis/impls/material-api';

export const materialContainer = new ContainerModule(bind => {
    bind(MaterialApi).to(MaterialApiImpl);
});
